import {
  GoogleAuthProvider,
  signInWithPopup,
  signOut as firebaseSignOut,
  signInAnonymously,
} from 'firebase/auth';
import { auth } from '../firebase';

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

// Use popup everywhere. signInWithRedirect has cross-origin state issues with
// custom domains (e.g. beta.chopmyshop.com) that cause getRedirectResult to
// return null. Popup works on both localhost (setupProxy.js relaxes COOP) and
// production Firebase Hosting (no COOP header set).
async function googleSignIn() {
  return signInWithPopup(auth, googleProvider);
}

// ── Sign in fresh with Google ─────────────────────────────────────────────────
export async function signInWithGoogle() {
  return googleSignIn();
}

// ── Upgrade an anonymous guest to a real Google account ───────────────────────
export async function upgradeGuestToGoogle() {
  return googleSignIn();
}

// ── No-op kept for backwards compat — redirect flow removed ──────────────────
// signInWithPopup is now used everywhere so there is no redirect to handle.
export async function handleRedirectResult() {
  return null;
}

// ── Sign out and drop back to anonymous guest ─────────────────────────────────
export async function signOutUser() {
  await firebaseSignOut(auth);
  await signInAnonymously(auth).catch(() => {});
}
